import React from 'react'
import { Container, Header , Button, Grid} from 'semantic-ui-react'


import "./Section3.css"

const Section3 = () => {
    return <Container className="Section3 p-1">
        <Header className="p-1-t p-1-b" size='huge'>Discover Naroon Experiences</Header>
        <Grid columns={2} >
                <Grid.Column>
                    <div className="bg-1 m-1-r">
                        <Header inverted size='huge' className="w-50 font-3 m-3-r m-3-l m-3-t">Things to do on your trip</Header>
                        <Button inverted className="rounded-10  m-3-r m-3-l"  size='big'>
                            Experiences
                        </Button>
                    </div>
                </Grid.Column>
                <Grid.Column >
                    <div className="bg-2 m-1-r">
                        <Header inverted size='huge' className="w-50 font-3 m-3-r m-3-l m-3-t">Things to do from home</Header>
                        <Button inverted className="rounded-10  m-3-r m-3-l text-black"  size='big'>
                            Online Experiences
                        </Button>
                    </div>
                </Grid.Column>
                
        </Grid>

     
</Container>
}
 export default Section3